import { Container } from "inversify";
import { RulesReflectionService } from "./rules/rules.reflection.service";
import { RuleOperationsService } from "./rules/rule-services";

export function setup(container: Container) {
	container.bind(RuleOperationsService).toSelf();
}



// WEBPACK FOOTER //
// ./src/app/rules/rules.config.ts